


















































































import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Constants from "./shared/constants";
import AuthStore from "./store/auth.store";
import NavSidebarStore from "./store/nav-sidebar.store";
import NavSidebar from "./components/layout/NavSidebar.vue";

@Component({
  components: { NavSidebar }
})
export default class App extends Vue {
  private readonly websiteName = Constants.WEBSITE_NAME;
  private darkModeEnabled = false;
  private readonly navSidebarStore: NavSidebarStore = getModule(
    NavSidebarStore,
    this.$store
  );
  private toggleSidebarDesktop() {
    this.navSidebarStore.toggleSidebarDesktop();
  }
  private toggleSidebarMobile() {
    this.navSidebarStore.toggleSidebarMobile();
  }
  private authStore: AuthStore = getModule(AuthStore, this.$store);

  private get isAuthenticated() {
    return this.authStore.getUserAuthenticationState;
  }

  @Watch("darkModeEnabled")
  changeTheme() {
    const htmlElement = document.documentElement;
    if (this.darkModeEnabled === true) {
      localStorage.setItem("theme", "dark");
      htmlElement.setAttribute("theme", "dark");
    } else {
      localStorage.setItem("theme", "light");
      htmlElement.setAttribute("theme", "light");
    }
  }
}
